import { render } from "./TopData.vue?vue&type=template&id=5992990c&scoped=true&ts=true"
import script from "./TopData.vue?vue&type=script&lang=ts"
export * from "./TopData.vue?vue&type=script&lang=ts"

import "./TopData.vue?vue&type=style&index=0&id=5992990c&scoped=true&lang=css"
import "./TopData.vue?vue&type=style&index=1&id=5992990c&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5992990c"]])

export default __exports__